import React, { memo, useEffect, useState } from 'react'
import axios from 'axios'
import { NavLink } from 'react-router-dom'
const Index = memo(() => {
  const [indexArr, setIndexArr] = useState([])
  const [imgUrl, setImgUrl] = useState("")
  const [pnum,setPnum] = useState()
  useEffect(() => {
    axios("http://common.scimall.org/api.php/demo/whzwz2021/index")
      .then((res) => {
        setIndexArr(res.data.data)
        const _arr = res.data.data
        const imgarr = _arr.filter((item) => item.id === 41)
        setImgUrl(imgarr[0].more)
        window.bannerImg = imgarr[0].more
      })
    axios('http://tp5.scimall.org/portal/clicks/index?h5Name=whzwz2021').then((res) => {
      setPnum(res.data.num)
    })
  }, [])
  const tab1arr = [0, 7, 10]
  return (
    <div className="indexwrap">
      <NavLink className="banner" to={'/content/41'}>
        <img src={imgUrl ? imgUrl : "./img/homebanner.png"} alt="" />
        <div className="pnum">
          当前参与{pnum*99}人
        </div>
      </NavLink>
      <div className="list">
        {
          indexArr.length &&
          indexArr.map((item, index) => {
            if (item.id <= 40) {
              if (parseInt(item.id) === 34) {
                return null;
              } else {
                return (
                  <NavLink className={tab1arr.includes(index) ? "tab1" : "tab2"} key={item.id} to={'/content/' + item.id}>
                    <img src={item.more} alt="" />
                  </NavLink>
                )
              }
            }
          })
        }
      </div>
      <div className="footer">
        <NavLink className='footertab' to='/lxwm'>
          联系我们
              </NavLink>
        <NavLink className='footertab' to='/zzdw'>
          组织单位
              </NavLink>
      </div>
    </div>
  )
})

export default Index